module.exports = __webpack_public_path__ + "img/ico-bell.5e532b5c.svg";